import { __assign } from "tslib";
export var toTitleCase = function (string) {
    return string &&
        string
            .toLowerCase()
            .split(' ')
            .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
            .join(' ');
};
export var toSentenceCase = function (string) {
    return string &&
        string
            .toLowerCase()
            .charAt(0)
            .toUpperCase() + string.slice(1);
};
export var pruneEmptyProps = function (object) {
    return Object.getOwnPropertyNames(object)
        .filter(function (prop) { return object[prop] !== null; })
        .filter(function (prop) { return object[prop] !== ''; })
        .reduce(function (acc, value) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[value] = object[value], _a)));
    }, {});
};
//# sourceMappingURL=helper.js.map